import { IPayloadAction } from '../session/session.actions';
import { IDiagnosticDebugImageUrl, IDocumentResult } from '../interfaces';

export const DiagnosticsActions = {
  DIAGNOSTICS_DEBUG_IMAGE_URLS_GET: '[Diagnostics] Get Debug Image URL ',
  DIAGNOSTICS_DEBUG_IMAGE_URLS_RECEIVED: '[Diagnostics] Debug Image URL Received',
  DIAGNOSTICS_DEBUG_IMAGE_URLS_ERROR: '[Diagnostics] Debug Image URL Error',
  DIAGNOSTICS_REPROCESS: '[Diagnostics] Debug Document',
  DIAGNOSTICS_REPROCESS_FINISHED: '[Diagnostics] ReScore Document Finished',
  DIAGNOSTICS_REPROCESSING_ERROR: '[Diagnostics] Error Reprocessing Document',
};

export class GetDebugImageUrls implements IPayloadAction {
  readonly type = DiagnosticsActions.DIAGNOSTICS_DEBUG_IMAGE_URLS_GET;
  constructor(public payload: string) {}
}

export class DebugImageUrlsReceived implements IPayloadAction {
  readonly type = DiagnosticsActions.DIAGNOSTICS_DEBUG_IMAGE_URLS_RECEIVED;
  constructor(public payload: IDiagnosticDebugImageUrl[]) {}
}

export class DebugImageUrlsError implements IPayloadAction {
  readonly type = DiagnosticsActions.DIAGNOSTICS_DEBUG_IMAGE_URLS_ERROR;
  constructor(public payload) {}
}

export class ReprocessDocument implements IPayloadAction {
  readonly type = DiagnosticsActions.DIAGNOSTICS_REPROCESS;
  constructor(public payload: { result: IDocumentResult, sessionId: string, debug?: boolean }) {}
}

export class ReprocessDocumentFinished implements IPayloadAction {
  readonly type = DiagnosticsActions.DIAGNOSTICS_REPROCESS_FINISHED;
}

export class ReprocessDocumentError implements IPayloadAction {
  readonly type = DiagnosticsActions.DIAGNOSTICS_REPROCESSING_ERROR;
  constructor(public payload) {}
}
